// extracted by mini-css-extract-plugin
module.exports = {"statisticBlock":"Na3","statistic":"Na5","discuss":"Na7","text":"Nah","statisticIcon":"Na9","statisticValue":"Na-"};